var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"id":"logo","to":"/call-log"}},[_c('img',{attrs:{"src":require("../assets/img/logo.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }